/*
* @Des 组件 实时定位
* @Description
* @Author 
* @Date 2021/8/5
*/
<template>
	<div class="view-tree-table">
		<!-- router-title-box start -->
		<div class="router-title-box" >
			<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
			<div class="router-title-tit"></div>
		</div>
		<!-- router-title-box end -->
		<InTimePosition ref="inTimePosition" />
	</div>
</template>

<script>
	// 引入组件 实时定位
	import InTimePosition from '@/components_pages/Location/InTimePosition'
	
	export default {
		/**
		 * @Des 组件名称
		 * @Auth
		 * @Date 2021/8/5
		 */
		name: 'LocationReal',
		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date 2021/8/5
		 */
		components: {
			// 组件 电子围栏
			InTimePosition,
		},
		/**
		 * @Des 接收数据
		 * @Auth
		 * @Date 2021/8/5
		 */
		props: {
			
		},
        
		/**
		 * @Des 加载执行 pre
		 * @Auth
		 * @Date 2021/8/5
		 */
		created() {
			
		},
		/**
		 * @Des 加载完成执行
		 * @Auth
		 * @Date 2021/8/5
		 */
		mounted() {
			
		},
		/**
		 * @Des 销毁之前执行
		 * @Auth
		 * @Date 2021/8/5
		 */
		beforeDestroy() {
			
		},
		
		/**
		 * @Des 数据模型
		 * @Auth
		 * @Date 2021/8/5
		 */
		data() {
			return {
				
			}
		},
		/**
		 * @Des 方法
		 * @Auth
		 * @Date 2021/8/5
		 */
		methods: {
			/**
			 * @Des 关闭路由 
			 * @Auth
			 * @Date 
			 */
			closeRouter () {
				// 跳转到 首页
				this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
			},// closeRouter
			
		},// methods
		
	}// export default
</script>

/* CSS */
<style lang="scss" scoped>
	.router-title-box {
		position: absolute;
	}
</style>


// WEBPACK FOOTER //
// src/views/system-manager/location/LocationReal.vue